"use client";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Icons } from "@/components/Icons";
import { Button } from "@/components/ui";

type GooglePromptProps = {
  googleReviewUrl: string;
  branchName?: string;
  onDismiss?: () => void;
};

/**
 * Post-submit nudge on the positive (4-5★) branch — asks the diner to also
 * leave a Google review. Renders only when `googleReviewUrl` is present
 * (null in M1 — the backend doesn't resolve a Google Place yet).
 */
export function GooglePrompt({ googleReviewUrl, branchName, onDismiss }: GooglePromptProps) {
  const { t } = useTranslation();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Button
        variant="primary"
        size="lg"
        full
        leading={<Icons.google size={18} />}
        onClick={() => window.open(googleReviewUrl, "_blank", "noopener,noreferrer")}
      >
        {t("v2.reviews.google.cta", "Leave a Google review")}
      </Button>
      <Button variant="ghost" size="md" full onClick={onDismiss}>
        {t("v2.reviews.google.no_thanks", "No thanks")}
      </Button>
      {branchName && (
        <div style={{ textAlign: "center", fontSize: 13.5, color: "var(--ink-3)", marginTop: 4 }}>
          {t("v2.reviews.google.helps_reach", "It helps {{branch}} reach more people who'd love their food.", {
            branch: branchName,
          })}
        </div>
      )}
    </div>
  );
}
